





















import { computed, defineComponent } from '@vue/composition-api';
import { useMembershipInfo } from '../../utils/membership-info';
import { useStore } from '../../../composables';
import { ASecondaryBtn } from '../../base/app/buttons';
import StepHeader from '../modal-components/StepHeader.vue';
import NeedHelp from '../modal-components/NeedHelp.vue';

export default defineComponent({
  name: 'CancelWarnStep',
  components: { StepHeader, NeedHelp, ASecondaryBtn },
  setup() {
    const store = useStore();
    const username = computed(() => store.getters['authentication/firstname']);
    const { membershipName } = useMembershipInfo();
    return { username, membershipName };
  }
});
